import { atom } from 'recoil';

const selectedStoreId = atom<string>({
  key: 'selectedStoreId',
  default: '',
});

export default selectedStoreId;
